<template>
     <div class="orderservices-search">
          <PageTitle 
                icon="fa fa-clone" 
                main="Record" sub="Order Service" 
                />
            <b-form 
                v-show="mode === 'save' || mode === 'remove' || mode === 'read'" >
             <input 
                id="orderservice-id" 
                type="hidden" 
                v-model="orderservice.id" />
             <b-row>
                <b-col md="2" sm="12">
                    <b-form-group
                    label="Order Date:"
                    label-for="orderservice-date_order_service"
                    >
                    <b-form-input
                    id="orderservice-date_order_service"
                    type="date"
                    v-model="orderservice.date_order_service"
                    :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                    size="sm"
                    />
                    </b-form-group>
                </b-col>
                <b-col md="2" sm="12">
                    <b-form-group
                    label="Scheduled Date:"
                    label-for="orderservice-date_scheduled_order_service"
                    >
                    <b-form-input
                    id="orderservice-date_scheduled_order_service"
                    type="date"
                    v-model="orderservice.date_scheduled_order_service"
                    :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                    size="sm"
                    />
                    </b-form-group>
                </b-col>
                <b-col md="4" sm="12">
                    <b-form-group 
                        label="Service:" 
                        label-for="orderservice-default_service_type_id_order_service">
                        <b-select 
                            id="orderservice-default_service_type_id_order_service"
                            @input="loadServiceProvider()"
                            size="sm"
                            :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            :options="defaultservicetypes" 
                            v-model="orderservice.default_service_type_id_order_service" 
                            />
                    </b-form-group>
                </b-col> 
                 <b-col md="4" sm="12">
                    <b-form-group 
                        label="Service Provider:" 
                        label-for="orderservice-service_provider_id_contract">
                        <b-select 
                            id="orderservice-service_provider_id_contract"
                            size="sm"
                            :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            :options="serviceproviders" 
                            v-model="orderservice.service_provider_id_contract" 
                            />
                    </b-form-group>
                </b-col>
                
             </b-row>    
             <b-row>
                 <b-col md="4" sm="12">
                    <div class="form-group">
                        <div class="form-check">
                            <input class="form-check-input" 
                                v-model="orderservice.service_payment_fixed_order_service" 
                                true-value="1" false-value="0" 
                                type="checkbox" 
                                 :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
                                id="orderservice-service_payment_fixed_order_service"
                            >
                            <label class="form-check-label" for="orderservice-service_payment_fixed_order_service">
                                Paid service (Fixed Value)?
                            </label>
                        </div>
                    </div>
                </b-col>
                 <b-col md="4" sm="12">
                    <div class="form-group">
                        <div class="form-check">
                            <input class="form-check-input" 
                                v-model="orderservice.service_receipt_fixed_order_service" 
                                true-value="1" false-value="0" 
                                type="checkbox" 
                                 :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
                                id="orderservice-service_receipt_fixed_order_service"
                            >
                            <label class="form-check-label" for="orderservice-service_receipt_fixed_order_service">
                                Receipt service (Fixed Value)?
                            </label>
                        </div>
                    </div>
                </b-col>
             </b-row>
              <b-row>
                 <b-col md="8" sm="12">
                        <b-form-group 
                            label="Comments:" 
                            label-for="orderservices-comments_provider_contract">
                        <b-form-textarea id="orderservices-comments_provider_contract"
                            :rows="3"
                            :max-rows="6"
                            size="sm"
                            v-model="orderservice.comments_provider_contract"
                            :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            placeholder="Comments" />
                    </b-form-group>
                </b-col>
             </b-row>

        <br>
         </b-form>

            <hr v-show="mode === 'save'">
              <b-row>
                <b-col xs="12">
                   <b-button  
                        size="sm" 
                        variant="light" 
                        title="Add (No Service Contract)"
                        class="mt-2  mb-2 fa fa-plus" 
                        v-show="mode !== 'save' && mode !== 'remove'"
                        @click="alterModo">
                        No Service Contract
                    </b-button>
                    <b-button  
                        size="sm" 
                        variant="light" 
                        title="Add (Service Contract)"
                        class="mt-2 ml-2 mb-2 fa fa-plus" 
                        v-show="mode !== 'save' && mode !== 'remove'"
                        @click="alterModo">
                        Service Contract
                    </b-button>
                    <b-button 
                        size="sm" 
                        variant="light"
                         title="Save"
                        class="mt-2 mb-2 ml-2 fa fa-save" 
                        v-if="mode === 'save'"
                        @click="save">
                        </b-button>
                    <b-button 
                        size="sm" 
                        variant="light" 
                         title="Delete"
                        class="mt-2 mb-2 ml-2 fa fa-trash" 
                        v-if="mode === 'remove'"
                        @click="remove">
                    </b-button>
                    <b-button 
                        size="sm" 
                        btn-sm 
                        variant="light" 
                         title="Back"
                        class="mt-2 mb-2 ml-2 fa fa-mail-reply"  
                        v-if="mode === 'remove' || mode === 'save' || mode === 'read' "
                        @click="reset">
                    </b-button>
                    <b-button 
                         size="sm" 
                         class="mt-2 mb-2 ml-2 fa" 
                          title="Search"
                         :class="icon" 
                         @click="[loadOwnerContracts(),toggleBusy(),showTable = !showTable]" 
                         variant="light" >
                    </b-button>
                </b-col>
            </b-row >
                     <b-card class="ownercontract-search-card" v-show="mode !== 'save' && mode !== 'remove'" >
                        <b-tabs card >
                            <b-tab title="Service Request" active>

                                <b-row>
                                    <b-col md="12" sm="12">
                                        <div class="form-group">
                                            <input 
                                                type="text" 
                                                size="sm" 
                                                icon="search" 
                                                v-model="search_request" 
                                                placeholder="Search by tenant name" 
                                                class="form-control">
                                        </div>
                                        </b-col>
                                </b-row>
                            
                            </b-tab>
                            <b-tab title="Real State">

                                <b-row>
                                    <b-col md="12" sm="12">
                                        <div class="form-group">
                                            <input 
                                                type="text" 
                                                size="sm" 
                                                icon="search" 
                                                v-model="search_real_state" 
                                                placeholder="Search by real state name" 
                                                class="form-control">
                                        </div>
                                        </b-col>
                                </b-row>

                            </b-tab>
                        </b-tabs>
                    </b-card>
            <b-row v-show="mode !== 'save' && mode !== 'remove'">
                

             
          <transition  name="slide" type="animation" appear>       
            <b-table 
                 :busy="isBusy"  
                class="table-responsive" 
                :per-page="perPage" 
                :current-page="currentPage" 
                hover 
                 head-variant="dark" 
                v-show="showTable"
                :items="filteredList" 
                :fields="fields">
                <template v-slot:table-busy>
                    <div class="text-center text-info my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Loading...</strong>
                    </div>
                </template>
               <template v-slot:cell(actions)="data">     
                    <b-button  
                        title = "View" 
                        size="sm" 
                        variant="light" 
                        @click="loadOwner(data.item, 'read')" 
                        class="mr-2 mt-2">
                        <i class="fa fa-drivers-license-o"></i>
                    </b-button>
                    <b-button  
                        title = "Edit" 
                        size="sm" 
                        variant="light" 
                        @click="loadOwner(data.item)" 
                        class="mr-2 mt-2">
                        <i class="fa fa-pencil"></i>
                    </b-button>
                     <b-button  
                        title = "Delete" 
                        size="sm" 
                        variant="light" 
                        @click="loadOwner(data.item, 'remove')" class="mr-2 mt-2">
                        <i class="fa fa-trash"></i>
                    </b-button>
                </template>    
         </b-table> 
          </transition>
          <transition  name="slide" type="animation" appear>
            <b-pagination
                v-show="showTable"
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
                size="sm"
                aria-controls="my-table"
            ></b-pagination>
          </transition>
        </b-row>
            <b-modal
            id="modalProviderContractItem"
            ref="modal"
            title-tag="h6"
            title="Service Detail"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="saveItem"
        >
          <b-form>
                <b-row>
                    <b-col md="12" sm="12">
                       <b-form-group 
                        label="Service:" 
                        label-for="orderservicesitem-default_service_type_id_contract_item">
                        <b-select 
                            id="orderservicesitem-default_service_type_id_contract_item"
                            size="sm"
                            :options="defaultservicetypes" 
                            v-model="orderservicesitem.default_service_type_id_contract_item" 
                            />
                    </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                     <b-col md="3" sm="12">
                        <b-form-group
                            label="Fixed Value:"
                            label-for="orderservicesitem-fixed_value_contract_item"
                        >
                            <b-form-input
                                id="orderservicesitem-fixed_value_contract_item"
                                type="number"
                                v-model="orderservicesitem.fixed_value_contract_item"
                                size="sm"
                                step="0.02"
                                pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="3" sm="12">
                        <b-form-group
                            label="Hourly Rate:"
                            label-for="orderservicesitem-hourly_rate_contract_item"
                        >
                            <b-form-input
                                id="orderservicesitem-hourly_rate_contract_item"
                                type="number"
                                v-model="orderservicesitem.hourly_rate_contract_item"
                                size="sm"
                                step="0.02"
                                pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
          </b-form>
        </b-modal>
     </div>
</template>

<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import PageTitle from '../template/PageTitle'

var moment = require('moment-timezone')

export default {
    name: 'OrderServiceSearch',
    components: {PageTitle },
    data: function() {
        return {
                mode: 'insert',
                search: '',
                search_request: '',
                search_real_state: '',
                orderservice: {},
                orderservicesitem: {},
                orderservicesitems:[],
                serviceproviders:[],
                orderservices: [],
                orderservicerequests: [],
                orderservicerealstates: [],
                orderservicesrequestservice: [],
                orderservicescontracts:[],
                defaultservicetypes:[],
                perPage: 5,
                currentPage: 1,
                 isBusy: false,
                 showTable: false,
                headerBgVariant: 'dark',
                headerTextVariant: 'light',
                bodyBgVariant: 'light',
                bodyTextVariant: 'dark',
                footerBgVariant: 'warning',
                footerTextVariant: 'dark',
                fieldsServiceRequest: [
                {
                    key: 'date_order_service',label: 'Order Date',sortable: true,
                            formatter: value =>
                            value ? moment.utc(value).format('MM-DD-YYYY') : '',variant: 'light'
                    },
                     {
                        key: 'date_scheduled_order_service',label: 'Date Scheduled',sortable: true,
                            formatter: value =>
                            value ? moment.utc(value).format('MM-DD-YYYY') : '',variant: 'light'
                    },
                    { key: 'name_service_provider', label: 'Service Provider', sortable: false ,variant: 'light'},
                    { key: 'name_tenant', label: 'Tenant', sortable: false ,variant: 'light'},
                    { key: 'comments_order_service', label: 'Comments', sortable: false ,variant: 'light'},
                  
               
                { key: 'actions', label: 'Action',variant: 'light' },
    
                ],
                fieldItem: [
                    { key: 'name_default_service_type', label: 'Service', sortable: false ,variant: 'light'},   
                    { key: 'fixed_value_contract_item', label: 'Fixed Value', sortable: false ,variant: 'light'},   
                    { key: 'hourly_rate_contract_item', label: 'hourly Rate', sortable: false ,variant: 'light'},   
                    { key: 'actions', label: 'Action',variant: 'light' }
                ]
               
            }
        },
        computed: {
            filteredListRequest() {
                return this.orderservicerequests.filter(orderservices => {
                    return orderservices.name_tenant.toLowerCase().includes(this.search_request.toLowerCase())
                    })
            },
            filteredListRealState() {
                return this.orderservicerealstates.filter(orderservices => {
                    return orderservices.name_real_state.toLowerCase().includes(this.search_real_state.toLowerCase())
                    })
            },
            compan(){
                return this.$store.state.compan
            },
            icon() {
            return this.showTable ? "fa-retweet" : "fa-search";
            },
            rows() {
                return this.orderservices.length
            },
            user(){
                    return this.$store.state.user
            },
        },
        methods:{
             async showMsgBoxApproval(item) {
                this.boxCancel = ''
                this.$bvModal
                    .msgBoxConfirm('Do you want to approval the record?', {
                    title: 'Please confirm',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'success',
                    okTitle: 'Yes',
                    cancelTitle: 'No',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(async value => {
                    this.boxCancel = value
                    if (this.boxCancel === true) {
                        await this.approval(item)
                    }
                })
            },
             async showMsgBoxCanceled(item) {
                this.boxCancel = ''
                this.$bvModal
                    .msgBoxConfirm('Do you want to canceled the record?', {
                    title: 'Please confirm',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Yes',
                    cancelTitle: 'No',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(async value => {
                    this.boxCancel = value
                    if (this.boxCancel === true) {
                        await this.approval(item)
                    }
                })
            },
            formatDateTime(date) {
                return moment(date)
                    .utcOffset(-3)
                    .format('YYYY-MM-DD LT')
            },
            formatDate(value) {
                return moment(value)
                    .format('YYYY-MM-DD')
            },
            toggleBusy() {
                this.isBusy = !this.isBusy
            },
            loadOwnerContracts(){
                const url = `${baseApiUrl}/orderservicesbycompany/${this.compan.id}`
                axios(url).then(res =>{
                     this.orderservices = res.data
                      this.isBusy = false
                })
            },
            alterModo() {
                    this.mode = 'save'
                    this.orderservice = {}
                    this.orderservicesitem = {}
                    this.orderservicesitems = []
                    this.$refs.searchFocus.focus();
            },
             reset() {
                this.mode = 'insert'
                this.loadOwnerContracts()              
                this.orderservices = {}
            },
            openModalItem() {
                this.$bvModal.show('modalProviderContractItem')
            },
            loadServiceProviderContractItem(item){
                this.orderservicesitem = {...item}
            },
            async approval(item) {

                 const method = 'put'

                  await axios[method](
                        `${baseApiUrl}/orderservicesapproval/${item.id}`,
                        this.item
                    )
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.loadOwnerContracts()

                        })
                        .catch(showError)

           },
             async canceled(item) {

                 const method = 'put'

                  await axios[method](
                        `${baseApiUrl}/orderservicescanceled/${item.id}`,
                        this.item
                    )
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.loadOwnerContracts()

                        })
                        .catch(showError)

           },
            async save() {

                const method = this.orderservices.id ? 'put' : 'post'
                const id = this.orderservices.id ? `/${this.orderservices.id}` : ''

                if(this.orderservices.id){
                    this.orderservices.update_date_service_contract = this.formatDateTime(Date())
                    this.orderservices.update_user_service_contract = this.user.id
                }else{
                    this.orderservices.user_id_provider_contract = this.user.id
                    this.orderservices.company_id_service_provider_contract = this.compan.id
                }

                await axios[method](`${baseApiUrl}/orderservices${id}`, this.orderservices)
                    .then(() => {
                        this.$toasted.global.defaultSuccess()
                        this.reset()
                    })
                    .catch(showError)
            },
            remove() {
                    const id = this.orderservices.id
                    axios.delete(`${baseApiUrl}/orderservices/${id}`)
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.reset()
                        })
                        .catch(showError)
            },
            async saveItem(){

                const method = this.orderservicesitem.id ? 'put' : 'post'
                const id = this.orderservicesitem.id ? `/${this.orderservicesitem.id}` : ''

                if(this.orderservicesitem.id){
                    this.orderservices.update_date_contract_item = this.formatDateTime(Date())
                    this.orderservices.update_user_id_contract_item = this.user.id
                }else{
                    this.orderservicesitem.user_id_contract_item = this.user.id
                }

                await axios[method](`${baseApiUrl}/orderservicesitems${id}`, this.orderservicesitem)
                    .then(() => {
                        this.$toasted.global.defaultSuccess()
                        this.loadServiceProviderContractItems()
                    })
                    .catch(showError)
            },
            loadOwner(orderservices, mode = 'save') {
                this.mode = mode
                 if(orderservices.date_order_service) orderservices.date_order_service = this.formatDate(orderservices.date_order_service)
                 if(orderservices.date_scheduled_order_service) orderservices.date_scheduled_order_service = this.formatDate(orderservices.date_scheduled_order_service)
                this.orderservices = { ...orderservices }
                this.loadServiceProvider()
     
            },
            loadServiceProvider(){

                const url = `${baseApiUrl}/serviceprovidecontractitemsbydefaultservices/${this.compan.id}/?default_service_type_id=${this.orderservice.default_service_type_id_order_service}`
                axios(url).then(res =>{
                     this.serviceproviders = res.data.map(type => {
                         return { value: type.id, text: type.name_service_provider + ' - Price: ' + ' Fixed: ' + type.fixed_value_contract_item + ' |' + ' Hourly: ' + type.hourly_rate_contract_item }
                    })
                
                })
            },
            loadServiceProviderContractItems(){
                const url = `${baseApiUrl}/orderservicesitemsbycontract/${this.orderservices.id}`
                axios(url).then(res =>{
                     this.orderservicesitems = res.data
                })
            },
             loadDefaultServiceRequests() {
                const url = `${baseApiUrl}/defaultservicetypesbycompany/${this.compan.id}`
                axios.get(url).then(res => {
                    this.defaultservicetypes = res.data.map(type => {
                        return { value: type.id, text: type.name_default_service_type }
                    })
                })
            },

        },
        mounted(){                
            this.loadOwnerContracts()
            this.loadDefaultServiceRequests()
            this.showTable = true
        }
}
</script>

<style>


    .orderservices-search{
        font-size: 0.75rem;
        color: white;
   
    }

    .orderservices-search button{
        font-size: 0.75rem;
    }

     .orderservices-search select{
        font-size: 0.75rem;
    }

    .orderservices-search input{
        font-size: 0.75rem;
    }

    .orderservices-search-card label{
        font-size: 0.75rem;
        color: black;
   
    }

      .orderservices-search textarea{
            font-size: 0.75rem;
        }


      #modalImmobile {
        font-size: 0.75rem;
    }

    #modalProviderContractItem button{
        font-size: 0.75rem;
    }

     #modalProviderContractItem input{
        font-size: 0.75rem;
    }

      #modalProviderContractItem select{
        font-size: 0.75rem;
    }

      #modalProviderContractItem label{
        font-size: 0.75rem;
        color: black;
    }




    
@keyframes slide-in {
  from {
    transform: translateY(40px);
  }
  to {
    transform: translateY(0);
  }
}

@keyframes slide-out {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(40px);
  }
}

.slide-enter-active {
  animation: slide-in 1s ease;
  transition: opacity 1s;
}

.slide-leave-active {
  animation: slide-out 1s ease;
  transition: opacity 1s;
}

.slide-enter,
.slide-leave-to {
  opacity: 0;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}

</style>
